var _path, _path2, _path3, _path4, _path5, _path6, _path7, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoHeader(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 165,
    height: 80,
    viewBox: "0 0 165 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M122.952 49.2749C124.151 50.4805 125.568 51.429 127.203 52.124C128.837 52.819 130.655 53.1836 132.614 53.1913C134.066 53.1913 135.482 52.9725 136.827 52.4964C138.171 52.0549 139.405 51.4366 140.531 50.5957C141.623 49.7932 142.567 48.8065 143.365 47.6738C144.163 46.5449 144.744 45.3008 145.106 43.9147H139.405C139.153 44.5713 138.79 45.1549 138.316 45.6656C137.843 46.1763 137.3 46.6141 136.682 46.9443C136.063 47.309 135.448 47.6008 134.757 47.7851C134.066 47.9656 133.34 48.077 132.614 48.077C131.381 48.077 130.254 47.8581 129.273 47.4204C128.253 47.0211 127.382 46.4374 126.657 45.6695C125.931 44.9015 125.389 44.0261 124.988 43.0393C124.59 42.0563 124.407 40.9582 124.407 39.7909C124.407 38.6236 124.587 37.5294 124.988 36.5426C125.385 35.5558 125.931 34.6803 126.657 33.9124C127.386 33.1444 128.257 32.5608 129.273 32.1231C130.254 31.7199 131.381 31.501 132.614 31.501C133.34 31.501 134.066 31.6085 134.757 31.7928C135.448 31.9733 136.063 32.2652 136.682 32.5954C137.3 32.9601 137.843 33.3978 138.316 33.9085C138.786 34.4192 139.149 35.0028 139.405 35.6594H145.106C144.744 34.2733 144.163 32.9947 143.365 31.862C142.567 30.7293 141.62 29.7809 140.531 28.94C139.405 28.1337 138.171 27.5155 136.827 27.0394C135.482 26.6017 134.066 26.3828 132.614 26.3828C130.651 26.3828 128.837 26.7092 127.203 27.4041C125.568 28.0991 124.151 29.0475 122.952 30.2531C121.753 31.4588 120.81 32.8834 120.118 34.5267C119.431 36.1701 119.103 37.921 119.103 39.7832C119.103 41.6455 119.427 43.3963 120.118 45.0397C120.81 46.6831 121.753 48.0692 122.952 49.2749Z",
    fill: "#006DF0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M86.8147 37.1173C87.867 37.5213 88.8086 38.0677 89.5711 38.7641C90.3336 39.4952 90.9474 40.3724 91.4202 41.3613C91.8548 42.3501 92.0721 43.4467 92.0721 44.6549C92.0721 45.863 91.8548 46.925 91.4202 47.91C90.9474 48.8988 90.3336 49.7761 89.5711 50.4725C88.8086 51.2035 87.867 51.7538 86.8147 52.154C85.7282 52.558 84.5654 52.7772 83.2997 52.7772H70.6387V26.7979H89.8608V31.846H75.9304V36.5286H83.2997C84.5692 36.5324 85.7282 36.7171 86.8147 37.1173ZM85.9456 42.2424C85.2555 41.6922 84.3519 41.3997 83.2273 41.3997H75.9304V47.8753H83.2273C84.3519 47.8753 85.2555 47.5829 85.9456 47.0327C86.6356 46.4825 86.9596 45.7168 86.9596 44.6549C86.9596 43.5929 86.6356 42.7888 85.9456 42.2424Z",
    fill: "#006DF0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M101.949 52.7772H96.8799V26.7979H101.949V37.8099L110.965 26.7979H117.267L106.984 39.2758L119.412 52.7772H112.794L101.949 40.9958V52.7772Z",
    fill: "#006DF0"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M40.0237 60C51.0824 60 60.0473 51.0457 60.0473 40C60.0473 28.9543 51.0824 20 40.0237 20C28.9649 20 20 28.9543 20 40C20 51.0457 28.9649 60 40.0237 60Z",
    fill: "url(#paint0_linear_1039_525)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M40.0237 60C51.0824 60 60.0473 51.0457 60.0473 40C60.0473 28.9543 51.0824 20 40.0237 20C28.9649 20 20 28.9543 20 40C20 51.0457 28.9649 60 40.0237 60Z",
    fill: "url(#paint1_linear_1039_525)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M29.0833 23.4152C22.4262 29.4636 23.1487 40.3612 30.699 47.7531C38.2468 55.145 49.7615 56.2366 56.4212 50.1856C57.1757 49.5 57.8355 48.7523 58.4013 47.9545C59.4604 45.5167 60.0476 42.8268 60.0476 40C60.0476 28.9543 51.0827 20 40.0239 20C36.3018 20 32.8169 21.0144 29.8311 22.7815C29.5757 22.9832 29.3263 23.1944 29.0833 23.4152Z",
    fill: "url(#paint2_radial_1039_525)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M30.4426 23.414C27.2917 28.207 30.9612 35.6557 38.6395 40.0465C46.3179 44.4399 55.094 44.1139 58.2475 39.3182C59.138 37.9639 59.4844 36.398 59.3501 34.7492C57.0411 26.2506 49.2632 20 40.0236 20C37.2333 20 34.5763 20.5701 32.163 21.5999C31.4834 22.1088 30.9029 22.7137 30.4426 23.414Z",
    fill: "url(#paint3_linear_1039_525)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1039_525",
    x1: 39.5231,
    y1: 59.5,
    x2: 39.8161,
    y2: 22.2884,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1E66E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.479167,
    stopColor: "#8CB4F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F1F7FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1039_525",
    x1: 57.0438,
    y1: 49,
    x2: 36.0372,
    y2: 32.9761,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4D87EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7EAAF0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_1039_525",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(63.7406 44.705) rotate(-152.981) scale(47.662 98.2039)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.103242,
    stopColor: "#4382EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.459935,
    stopColor: "#7EAAF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.630708,
    stopColor: "#B2CDF6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.794216,
    stopColor: "#F1F7FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1039_525",
    x1: 57.5058,
    y1: 26.9899,
    x2: 29.0119,
    y2: 31.0093,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9CBFF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.476252,
    stopColor: "#CCE0FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.770833,
    stopColor: "#E9F2FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F1F7FE"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoHeader);
export default __webpack_public_path__ + "static/media/logo_header.a89f6e3b65565b35f668613244c182c8.svg";
export { ForwardRef as ReactComponent };